import { render, staticRenderFns } from "./CorrelationNetworkPlot.vue?vue&type=template&id=3d89b1d0&scoped=true"
import script from "./CorrelationNetworkPlot.vue?vue&type=script&setup=true&lang=js"
export * from "./CorrelationNetworkPlot.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CorrelationNetworkPlot.vue?vue&type=style&index=0&id=3d89b1d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d89b1d0",
  null
  
)

export default component.exports